import { cn } from '@kidshome/ui';

/**
 * A gentle sprout glyph — the "no streak yet / fresh start" mark (kind gamification: never a shaming
 * zero), replacing the bare 🌱 emoji. Drawn as a calm outline so it reads softer than the filled
 * {@link FlameIcon}. Inherits `currentColor` and sizes to `1.1em` — mirrors {@link FlameIcon}.
 */
export function SproutIcon({ className }: { className?: string }): React.ReactElement {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      className={cn('inline-block size-[1.1em] shrink-0 align-[-0.15em]', className)}
    >
      <path d="M12 21v-7" />
      <path d="M12 14c0-3.3-2.7-6-6-6 0 3.3 2.7 6 6 6z" />
      <path d="M12 13.2c0-2.8 2.2-5 5-5 0 2.8-2.2 5-5 5z" />
    </svg>
  );
}
